import React, { useEffect, useState } from "react";
import TeamService from "services/TeamService";
import StatsCard from "components/StatsCard";
import { ReactComponent as WallofFameIcon } from "assets/img/icons/walloffame.svg";
import PeerRecognitionStatsDetails from "./PeerRecognitionStatsDetails";

export default ({ team_id, showSlideshow = true }) => {
  const [stats, setStats] = useState({ total_count: "-" });
  const [time, setTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [detailsOpened, setDetailsOpened] = useState(false);

  useEffect(() => {
    setLoading(true);

    (async () => {
      try {
        const response = await TeamService.getRecognitionStats(team_id, time);

        setStats({
          total_count: response.data.data.initiated_count,
          recognizers: response.data.data.users_created_celebration_count,
          recievers: response.data.data.users_got_celebrated_count,
        });

        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [team_id, time]);

  return (
    <StatsCard
      title="Recognition Stats"
      Icon={WallofFameIcon}
      loading={loading}
      stats={stats}
      time={time}
      setTime={setTime}
      onDetailsOpen={() => setDetailsOpened(true)}
      onDetailsClosed={() => setDetailsOpened(false)}
      statsClass="mt-30"
      backgroundClass="card-green"
      recognition={true}
    >
      <PeerRecognitionStatsDetails
        recognitionStats={stats}
        team_id={team_id}
        time={time}
        setTime={setTime}
        opened={detailsOpened}
      />
    </StatsCard>
  );
};
